import {Col} from "react-bootstrap";

const Booking = () => {
    return (
        <Col className={'border-1 border-black iframe-container'} md={4} sm={12}>
            <iframe title={'integration with central de pasajes'} className={'iframe-cdp'}
                    src="https://ecommerce.centraldepasajes.com.ar/agenciaframe.aspx?Token=g2icXkQIPMcul9ohlsGGkI%2bmwnHOFBheQjtz%2ba9BdGk%3d&age=cwa"/>
        </Col>
    );
}
export default Booking;